import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import { decryptAndRetrieveData } from './login/encript-decript';
import SignIn from './login/SignIn';

export default function Sidebar({ logoutComponent }) {
    const wfp_url = process.env.REACT_APP_WFP_URL
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const sidebarRef = useRef(null);
    const [activeLink, setActiveLink] = useState("SIERRA"); // Start with no active link

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const user = decryptAndRetrieveData("isAuth", '123456789')

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target) && !event.target.closest('.btn')) {
                setIsSidebarOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <>
            {/* Sidebar Toggle Button */}
            <button className="btn" style={{ padding: '0px', background: 'none', paddingRight: '20px' }} onClick={toggleSidebar} data-component="sidebar" data-target="left">
                <i className="fa fa-bars ms-1" style={{ color: 'black' }} />
            </button>

            {/* Sidebar */}
            <aside ref={sidebarRef} className={`nav left ${isSidebarOpen ? 'open' : ''}`}>
                <ul style={{ width: '100%' }}>
                    <li style={{ borderBottom: '1px solid lightgray' }}>
                        <div className="navbar-brand d-flex">
                            <div style={{ color: 'black', fontSize: '0.7em' }} id="logoRS-text">
                                {/* <h4 className="h4 m-0">CALIFORNIA FOREST</h4>
                                <h4 className="h4 m-0">INDUSTRY DIRECTORY</h4> */}
                                <img className="logo-w" src={"/img/CFID-logo.png"} alt="" />
                            </div>
                        </div>
                    </li>

                    <li className="p-0" onClick={() => setActiveLink("SIERRA")}>
                        <Link
                            to="/"
                            className="nav-link"
                            style={{ paddingLeft: '1em', backgroundColor: activeLink === "SIERRA" ? "#f0ecec" : "transparent" }}
                        >
                            <img className="logo-w" src={"/img/CFID-logo.png"} alt="" />
                        </Link>
                    </li>

                    <li className="p-0 d-flex" onClick={() => setActiveLink("Forest")}>
                        <a
                            href= {wfp_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="nav-link"
                            style={{ paddingLeft: '1em', backgroundColor: activeLink === "Forest" ? "#f0ecec" : "transparent" }}
                        >
                           <img className="logo-w" src={"/img/wfp.png"} alt="" />
                        </a>
                    </li>


                    <li className="p-0" style={{ borderBottom: '1px solid lightgray' }} onClick={() => setActiveLink("off-taker")}>
                        <Link
                            to="#"
                            className="nav-link"
                            style={{ paddingLeft: '2em', backgroundColor: activeLink === "off-taker" ? "#f0ecec" : "transparent" }}
                        >
                            Off-Taker Portal (Coming Soon)
                        </Link>
                    </li>

                    <li className='pt-0'>
                        <div className="auth-section">

                            {user ? (
                                <>
                                    <div style={{marginLeft : '10px'}}>Logged in as <strong>{localStorage.getItem('userName')}</strong></div>
                                    {/* <div style={{ marginBottom: '0.5em' }}>{user?.email}</div> */}
                                    <button className=" btn-primary1" onClick={logoutComponent}>
                                        Logout
                                    </button>
                                </>
                            ) : (
                                <div className="sign-in-btn">
                                    <SignIn side={'side'}/>
                                </div>
                            )}
                        </div>
                    </li>

                </ul>
            </aside>
        </>
    );
}
